import { render } from "./CaregiverProfile.vue?vue&type=template&id=4dbb1291&scoped=true"
import script from "./CaregiverProfile.vue?vue&type=script&lang=js"
export * from "./CaregiverProfile.vue?vue&type=script&lang=js"

import "./CaregiverProfile.vue?vue&type=style&index=0&id=4dbb1291&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbb1291"]])

export default __exports__